/*
 * @Author: zhangguoliang
 * @Date: 2022-11-19 10:44:01
 * @LastEditors: zhangguoliang
 * @LastEditTime: 2023-01-16 10:53:12
 */
import router from "@/router";
import { useStore } from "@/store";
import { getCMS } from "@/api/index";
import Cookies from "js-cookie";

router.beforeEach(async (to, from) => {
  const store = useStore();
  if (!store.menu?.length) {
    const res = await getCMS({
      pageNum: 1,
      pageSize: 12,
      Terminal: "pc",
      Port: 1,
    });
    const menu = (res.rows || [])
      .filter((item) => item.jumpUrl?.includes("http"))
      .map((item) => {
        const match = item.jumpUrl?.match(/^(https?:\/\/.*?)\//);
        return {
          name: `sub${item.sort}`,
          host: match[1],
          path: item.jumpUrl?.replace(match[1], ""),
          jumpUrl: item.jumpUrl,
        };
      });
    store.setMenu(menu);
  }
  if (to.path === '/login') {
    if (Cookies.get('cms_token')) {
      return '/';
    }
    Cookies.set('redirect', from.fullPath);
  }
  return true;
});

router.afterEach((to) => {
  document.title = (to.meta.title as string) || "乡农网";
});
